<template>
    <div class="flex h-full flex-col justify-center text-center">
        <div class="mb-4 text-8xl font-bold text-gray-900">
            {{ t('oops') }}
        </div>
        <p class="line-height-3 mb-5 mt-0 text-xl font-medium text-gray-700">
            {{ t('notFound.somethingWentWrong') }}
        </p>
        <nuxt-link
            :to="facilityHome"
            class="mt-4 text-gray-700"
        >
            <prime-button>{{ t('notFound.backToHome') }}</prime-button>
        </nuxt-link>
    </div>
</template>

<script setup lang="ts">
import PrimeButton from 'primevue/button'
import { useActiveFacility } from '~/composables/use-active-facility'
import { computed } from 'vue'
import { useRouteLink } from '~/composables/routing'
import { useI18n } from 'vue-i18n'
import { useNoSearchIndexing } from '~/composables/use-search-indexing'

// Soft errors can appear on public URLs, but their error content must not be indexed.
useNoSearchIndexing()

const activeFacility = useActiveFacility()
const { facilityHomeLink } = useRouteLink()
const { t } = useI18n({ useScope: 'global' })
const facilityHome = computed(() => facilityHomeLink(activeFacility.value.slug))
</script>
